import { useState } from "react";
import { faqList } from "@/mocks/home";

export default function FaqSection() {
  const [openId, setOpenId] = useState(faqList[0].id);

  return (
    <section id="faq" className="border-b border-background-200">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于更新与订阅，
              <br />
              新粉最常问的几个问题
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              从「几点更新」到「提醒怎么开」，这里都按最直白的方式答一遍。没找到答案的，去热评区问一句，老粉回得挺快。
            </p>
            <a
              href="#comments"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-question-answer-line"></i>
              </span>
              去热评区提问
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
              {faqList.map((item) => {
                const open = openId === item.id;
                return (
                  <div key={item.id}>
                    <button
                      type="button"
                      onClick={() => setOpenId(open ? "" : item.id)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                    >
                      <h3 className="text-sm font-bold text-foreground-900 md:text-base">{item.q}</h3>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                    {open && (
                      <p className="px-5 pb-5 text-xs leading-7 text-foreground-600 md:px-6 md:text-sm">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}